import React from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'

interface Props {

}

const RoundResultsCeoTransfer: React.FC<Props> = () => {
  return (
    <VerticalGroup full center wide>
      <Text size='6xl' bold colour='primaryDark' className='mb-2'>CEO Transfer</Text>
    </VerticalGroup>
  )
}

export default RoundResultsCeoTransfer

